export default import.meta.ROLLDOWN_FILE_URL_7JERBrkOwiC0E14WMNtXXg